/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath, clientSideUrl } from "../../utility/Constant";

const HomeAbout = () => {
  const { homeApi } = apiPath;
  const { clientHome } = clientSideUrl;
  const [homeAboutData, homeAboutLoading] = useFetch(homeApi);
  const [filteredData, setFilteredData] = useState();

  useEffect(() => {
    setFilteredData(
      homeAboutData?.filter((item) => item.section_type === "who-we-are")[0]
    );
  }, [homeAboutData]);

  if (homeAboutLoading) {
    return <Loading />;
  }
  const { who_we_are_title, section_type, who_we_are_description, _id } =
    filteredData ?? {};

  const data = [
    {
      elementType: "textField",
      label: "section title",
      type: "Text",
      name: "who_we_are_title",
      defaultValue: who_we_are_title,
      required: false,
    },
    {
      elementType: "textField",
      label: "section Description",
      type: "Text",
      name: "who_we_are_description",
      defaultValue: who_we_are_description,
      required: false,
    },
  ];

  const update = (data) => {
    updateData(homeApi, data, _id);
    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  return (
    <div>
      <div className="mb-2 w-full text-right font-semibold text-sm">
        <Link
          className="text-black hover:text-[#DB0029]"
          to={clientHome}
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit page
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="inline w-4 h-4 ml-1 align-text-top"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
              />
            </svg>
          </span>
        </Link>
      </div>
      <div className="bg-white p-5 shadow-md rounded-md border mt-5">
        {section_type && <GlobalForm data={data} update={update} />}
      </div>
    </div>
  );
};

export default HomeAbout;
